(function () {
  var root = document.querySelector('[data-lbfw]');
  if (!root) return;
  var modal = root.querySelector('[data-lbfw-modal]');
  var sheet = root.querySelector('[data-lbfw-sheet]');
  function openModal() {
    if (!modal || modal.open) return;
    modal.showModal();
    document.documentElement.classList.add('lbfw-lock');
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { modal.classList.add('is-open'); }); });
  }
  if (modal) {
    modal.addEventListener('close', function () { modal.classList.remove('is-open'); document.documentElement.classList.remove('lbfw-lock'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    [].forEach.call(modal.querySelectorAll('[data-close]'), function (b) { b.addEventListener('click', function () { modal.close(); }); });
  }
  [].forEach.call(root.querySelectorAll('[data-acc-group]'), function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      [].forEach.call(root.querySelectorAll('[data-acc-group="' + d.getAttribute('data-acc-group') + '"]'), function (o) { if (o !== d && o.open) o.open = false; });
    });
  });
  var form = root.querySelector('form');
  var steps = [].slice.call(root.querySelectorAll('[data-step]'));
  if (!form || !steps.length) {
    var done = root.querySelector('[data-lbfw-done]');
    if (done) { openModal(); done.focus({ preventScroll: true }); }
    return;
  }

  var bars = [].slice.call(root.querySelectorAll('.lbfw__progress i'));
  var label = root.querySelector('[data-lbfw-label]');
  var prev = root.querySelector('[data-prev]');
  var next = root.querySelector('[data-next]');
  var submit = root.querySelector('[data-submit]');
  var blocks = [].slice.call(root.querySelectorAll('[data-track-block]'));
  var wholesaleOnly = [].slice.call(root.querySelectorAll('[data-wholesale-only]'));
  var step2Title = root.querySelector('[data-step2-title]');
  var current = 0;
  var TITLES = { wholesale: 'Your business', partner: 'Your partnership' };

  root.classList.add('is-js');

  function setEnabled(el, on) {
    el.hidden = !on;
    [].forEach.call(el.querySelectorAll('input, select, textarea'), function (c) { c.disabled = !on; });
  }

  function track() {
    var c = form.querySelector('input[name="contact[Enquiry type]"]:checked');
    return c ? c.getAttribute('data-track') : '';
  }

  function applySector() {
    var t = track();
    blocks.forEach(function (b) {
      var on = b.getAttribute('data-track-block') === t;
      setEnabled(b, on);
      if (!on) return;
      var chosen = b.querySelector('input[data-sector]:checked');
      var key = chosen ? chosen.getAttribute('data-sector') : '';
      [].forEach.call(b.querySelectorAll('[data-group]'), function (g) {
        setEnabled(g, g.getAttribute('data-group') === key);
      });
      setEnabled(b.querySelector('.lbfw__common'), !!key);
    });
    wholesaleOnly.forEach(function (w) {
      w.hidden = t === 'partner';
      [].forEach.call(w.querySelectorAll('input'), function (i) { i.disabled = t === 'partner'; });
    });
    steps[1].setAttribute('data-step-title', TITLES[t] || 'Your details');
    step2Title.textContent = t === 'partner' ? 'About your partnership' : t === 'wholesale' ? 'About your business' : 'Tell us more';
  }

  function show(n) {
    current = n;
    steps.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
    bars.forEach(function (b, i) { b.classList.toggle('is-on', i <= n); });
    label.textContent = 'Step ' + (n + 1) + ' of ' + steps.length + ' · ' + steps[n].getAttribute('data-step-title');
    prev.hidden = n === 0;
    next.hidden = n === steps.length - 1;
    submit.hidden = n !== steps.length - 1;
  }

  function stepValid(n) {
    var fields = steps[n].querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].disabled && !fields[i].checkValidity()) {
        fields[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  function go(n) {
    show(n);
    var h = steps[n].querySelector('.lbfw__h');
    if (h) h.focus({ preventScroll: true });
    if (sheet) sheet.scrollTop = 0;
  }

  function pick(t) {
    var radio = form.querySelector('input[name="contact[Enquiry type]"][data-track="' + t + '"]');
    if (!radio) return;
    radio.checked = true;
    applySector();
    if (current !== 0) show(0);
  }

  [].forEach.call(root.querySelectorAll('[data-pick]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      pick(a.getAttribute('data-pick'));
      show(0);
      openModal();
      if (sheet) sheet.scrollTop = 0;
      var first = form.querySelector('#lbfw-name');
      if (first) first.focus({ preventScroll: true });
    });
  });

  next.addEventListener('click', function () { if (stepValid(current)) go(current + 1); });
  prev.addEventListener('click', function () { go(current - 1); });
  form.addEventListener('change', function (e) {
    if (e.target.name === 'contact[Enquiry type]' || e.target.hasAttribute('data-sector')) applySector();
  });

  form.addEventListener('submit', function (e) {
    if (!stepValid(current)) { e.preventDefault(); return; }
    var body = form.querySelector('[name="contact[body]"]');
    if (body && !body.value.trim()) {
      var data = new FormData(form);
      var parts = [];
      ['Enquiry type', 'Sector', 'Partner type', 'Company', 'Products of interest', 'Areas covered', 'Date or timeframe', 'State'].forEach(function (k) {
        var v = data.get('contact[' + k + ']');
        if (v) parts.push(k + ': ' + v);
      });
      body.value = (data.get('contact[Enquiry type]') === 'Partnership' ? 'Partnership enquiry. ' : 'Retail and distribution enquiry. ') + parts.join('. ') + '.';
    }
  });

  var hash = location.hash.replace('#', '');
  if (hash === 'partner' || hash === 'wholesale') { pick(hash); openModal(); }
  if (form.querySelector('.lbfw__errors')) openModal();
  applySector();
  show(0);
})();
